<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('labourInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="labourForm" :rules="rules" ref="labourForm" label-width="200px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskName1')" prop="subtaskId">
                    <el-select v-model="labourForm.subtaskId" disabled >
                      <el-option v-for="item in SubtaskList" :key="item.subtaskNumber" :label="item.subtaskName" :value="item.subtaskNumber"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workDate1')" prop="workDate">
										<el-date-picker v-model="labourForm.workDate" disabled type="date" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workContent1')" prop="workContent">
                    <el-input v-model="labourForm.workContent" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workDescribe1')" prop="workDescribe">
                    <el-input v-model="labourForm.workDescribe" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workHours1')" prop="workHours">
                    <el-input v-model="labourForm.workHours" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('travelHours1')" prop="travelHours" >
                    <el-input v-model="labourForm.travelHours" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('hardwareProductLine1')" prop="hardwareProductLine">
                    <el-select v-model="labourForm.hardwareProductLine" disabled>
											<el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceProductLine1')" prop="serviceProductLine">
                    <el-select v-model="labourForm.serviceProductLine" disabled>
											<el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row> -->
              <el-row>
                <el-col :xs="24" :md="12" v-if="caseFlag">
									<el-form-item :label="caseName" >
                    <el-input v-model="labourForm.ocmsCaseNumber" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12" v-if="accountFlag">
									<el-form-item :label="$t('accountName1')" >
                    <el-input v-model="labourForm.accountName" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('representativeSupport')" >
                    <el-input v-model="labourForm.representativeSupport" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('remark1')" >
                    <el-input v-model="labourForm.remark" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row v-if="this.$route.params.showRun=='Y'">
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getSubtaskList();
          this.getLabourHourData();
        },
        data () {
          return {
            rangeNumber: 10,
            labourForm: {
              projectId:null,
              taskId:null,
              subtaskId:null,
              workDate:null,
              workHours:null,
              workContent:null,
              travelHours:null,
              hardwareProductLine:null,
              serviceProductLine:null,
              ocmsCaseNumber:null,
              accountName:null,
            },
            caseFlag:false,
            caseName:null,
            accountFlag:false,
            SubtaskList:[],
            SubTList:[],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            rules: {
              subtaskId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              workHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              workContent: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              travelHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              ocmsCaseNumber: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
            }
          } 
        },
        methods: {
          getSubtaskList(){
            let url =`${this.$store.state.islhurl}subtask/getAllSubtaskToDetail`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.SubTList = res.data;
              }
            )
          },
          //回显数据
          getLabourHourData(){
            let url = `${this.$store.state.islhurl}labourHour/getInfo`
            let pm = {
              id: this.$route.params.id,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(pm)
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  this.filterSubtaskCode(res.labourHour.subtaskId);
                }, 500);
                //再进行赋值
                this.labourForm = res.labourHour;
                let labour = res.labourHour;
                if(labour.projectName == "MSN"){
                  this.caseFlag = true;
                  this.caseName = 'IPMS Project Number：';
                }else if(labour.projectName == "MSP"){
                  this.caseFlag = true;
                  this.caseName = 'PMS Project Number：';
                }else if(labour.taskName == "Maintenance"){
                  this.caseFlag = true;
                  this.caseName = 'OCMS Case Number：';
                }else if(labour.projectName == "CDMA"){
                  this.caseFlag = true;
                  this.caseName = 'Service Contract Number：';
                }else if(labour.taskName == "Case"){
                  this.caseFlag = true;
                  this.accountFlag = true;
                  this.caseName = 'OCMS Case Number：';
                }else if(labour.taskName == "NECCase"){
                  this.caseFlag = true;
                  this.caseName = 'NEC Case Number：';
                }else if(labour.projectName == "CDROD"){
                  this.caseFlag = true;
                  this.caseName = 'OCMS Case Number：';
                }else{
                  this.caseFlag = false;
                  this.accountFlag = false;
                }
              }
            )
          },
          returnList(){
            let pm = this.$route.params;
            if(pm.returnF == 'Y'){
              this.$router.push({name:'labourEngineer',params:pm});
            }else{
              this.$router.push({name:'labour',params:pm});
            }
          },
          filterSubtaskCode(filterVal){
            if(filterVal){
              let filterArr = this.SubTList.filter(item => {
                return item.subtaskNumber.toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
              })
              this.SubtaskList = filterArr;
            }else{
              this.SubtaskList = this.SubTList;
            }
          },
        },
    }
</script>


// WEBPACK FOOTER //
// src/view/labour/labourDetail.vue